import type { DiscountChipData } from "../types"
import styles from "../styles/widget.module.css"

export function DiscountChip({ data }: { data: DiscountChipData }) {
  return (
    <div className={styles["rc-discount"]}>
      <span className={styles["rc-discount-code"]}>{data.code}</span>
      <span>{data.label}</span>
      {data.expiresAt && (
        <span className={styles["rc-discount-expires"]}>
          · expires {data.expiresAt}
        </span>
      )}
    </div>
  )
}
